/*
 * Title: Leaderboard/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Leaderboard component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import Leaderboard from "@containers/fans/Leaderboard";
import { connect } from "react-redux";

type Props = {
  name: string;
  setPageYOffset: (value: number) => void;
};

const LeaderboardPage: React.FC<Props> = (props) => {

  
  React.useEffect(() => {
    const handleScroll = () => {
      const { setPageYOffset } = props;
      const pageYOffset = window.pageYOffset;
      setPageYOffset(pageYOffset);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, [props])


  return <Leaderboard name="title" />;
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { utilactions } = require("@redux/utilRedex");
  return {
    ...stateProps,
    setPageYOffset: (value: number) => dispatch(utilactions.setPageYOffset(value)),
  };
};

export default connect(undefined, undefined,mergeProps)(LeaderboardPage);
